/**
 * card-color-switch.js
 *
 * Al click di un pallino colore (.swatch-btn) aggiorna la card prodotto:
 *   1. immagine di copertina + immagine di hover del colore scelto
 *   2. prezzo e badge sconto della variante
 *   3. href di arrivo della card
 *
 * I dati arrivano da <script type="application/json" class="card-color-data">
 * dentro .card-wrapper, emesso da snippets/card-color-data.liquid.
 *
 * Il listener e' DELEGATO su document: filtri e paginazione (facets.js)
 * rimpiazzano le card nel DOM, quindi un listener attaccato a ogni pallino
 * morirebbe al primo filtro applicato.
 *
 * NOTA: data-variant-id sui link resta quello della variante di default, per
 * scelta. window.datalayer_items e' popolato con una sola chiave per card
 * (card-product.liquid), quindi riscriverlo farebbe pushare items:[undefined]
 * in GTM. L'evento select_item continua a riportare la variante di default.
 */
(function () {
  'use strict';

  // Le stesse larghezze dello srcset generato in Liquid. Nel JSON viaggia un
  // solo URL col placeholder __W__: ricostruire qui evita di trasportare
  // stringhe srcset complete (~600 byte per immagine per colore).
  // Placeholder senza graffe: con '{W}' il lexer di Liquid non chiude l'output
  // tag e il tema non compila.
  var WIDTHS = [165, 360, 533, 720, 940, 1066];
  var DEFAULT_WIDTH = 533;

  function srcFor(template, width) {
    return template.replace('__W__', width);
  }

  function buildSrcset(template) {
    return WIDTHS.map(function (w) {
      return srcFor(template, w) + ' ' + w + 'w';
    }).join(', ');
  }

  function readData(card) {
    if (card._cardColorData !== undefined) return card._cardColorData;

    var node = card.querySelector('.card-color-data');
    if (!node) {
      card._cardColorData = null;
      return null;
    }
    try {
      card._cardColorData = JSON.parse(node.textContent);
    } catch (e) {
      card._cardColorData = null;
    }
    return card._cardColorData;
  }

  function applyImage(img, template, alt) {
    if (!img || !template) return;
    img.setAttribute('src', srcFor(template, DEFAULT_WIDTH));
    img.setAttribute('srcset', buildSrcset(template));
    if (typeof alt === 'string') img.setAttribute('alt', alt);
  }

  function applyImages(card, entry) {
    var primary = card.querySelector('.card-img-primary');
    applyImage(primary, entry.img1, entry.alt1);

    var secondary = card.querySelector('.card-img-secondary');

    if (!entry.img2) {
      // Il colore non ha una seconda foto nel suo blocco.
      // La secondaria va RIMOSSA, non nascosta: le regole hover sono
      //   img:first-child:not(:only-child) { opacity: 0 }
      //   img + img                        { opacity: 1 }
      // quindi con un display:none la primaria continuerebbe a sparire in
      // hover senza nulla a sostituirla, e la card diventerebbe bianca.
      // Rimuovendola la primaria torna :only-child e riceve lo zoom.
      if (secondary) secondary.remove();
      return;
    }

    if (!secondary && primary) {
      // Alcune card non hanno la seconda <img> perche' la variante di default
      // non aveva foto successiva. La creiamo clonando la primaria, cosi'
      // eredita sizes/loading/width senza duplicarne gli attributi qui.
      secondary = primary.cloneNode(false);
      secondary.classList.remove('card-img-primary');
      secondary.classList.add('card-img-secondary');
      secondary.setAttribute('loading', 'lazy');
      secondary.setAttribute('alt', '');
      primary.parentNode.appendChild(secondary);
    }

    applyImage(secondary, entry.img2, entry.alt2);
  }

  function applyPrice(card, entry) {
    var price = card.querySelector('.price');
    if (!price) return;

    // .price__regular e .price__sale sono entrambi nel markup: e' questa classe
    // a decidere quale dei due si vede (vedi snippets/price.liquid).
    price.classList.toggle('price--on-sale', !!entry.onSale);

    var regular = price.querySelector('.price__regular .price-item--regular');
    if (regular) regular.textContent = entry.price;

    var sale = price.querySelector('.price__sale .price-item--sale');
    if (sale) sale.textContent = entry.price;

    var compareAt = price.querySelector('.price__sale s.price-item--regular');
    if (compareAt) compareAt.textContent = entry.compareAt || '';
  }

  function applyDiscountBadge(card, entry) {
    var badge = card.querySelector('[data-card-discount]');
    // Se il prodotto non e' in saldo il badge non esiste in pagina: in quel caso
    // un colore in saldo non mostrera' la percentuale. Ricostruirlo qui
    // richiederebbe di duplicare in JS la logica b2b/locale/metafield.
    if (!badge) return;

    if (!entry.onSale || !entry.pct) {
      badge.style.display = 'none';
      return;
    }

    badge.style.display = '';
    var pct = badge.querySelector('[data-card-pct]');
    if (pct) pct.textContent = entry.pct;
  }

  function applyLinks(card, entry) {
    if (!entry.url) return;
    card.querySelectorAll('[data-card-link]').forEach(function (link) {
      link.setAttribute('href', entry.url);
    });
  }

  function markPressed(card, color) {
    card.querySelectorAll('.swatch-btn').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.color === color ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest('.swatch-btn');
    if (!button) return;

    var card = button.closest('.card-wrapper');
    if (!card) return;

    var data = readData(card);
    if (!data) return;

    var entry = data[button.dataset.color];
    if (!entry) return;

    applyImages(card, entry);
    applyPrice(card, entry);
    applyDiscountBadge(card, entry);
    applyLinks(card, entry);
    markPressed(card, button.dataset.color);
  });
})();
